module.exports = __webpack_public_path__ + "static/media/ceilings_material_10y_y.08cbb074.csv";